"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Article = require("./Article");
Object.keys(_Article).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Article[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Article[key];
    }
  });
});